import { createSelector } from 'reselect';
import { NONE_CHOOSEN } from '../../utils/gtmEvents';
import {
  getSelectedFromDate,
  getSelectedToDate,
  getTotalFilteredCount,
  getPriceRange,
  getSelectedPrice,
  getTripTypes,
  getSelectedTripTypes,
  getSelectedCountryCodes,
  getSelectedDestinationCodes,
  getSelectedDepartures,
  getSelectedTripLength,
} from './filtersSelectors';

const DAY_IN_MS = 60 * 60 * 24 * 1000;

export const getGTMBaseData = createSelector([
  getSelectedFromDate,
  getSelectedToDate,
  getTotalFilteredCount,
  getPriceRange,
  getSelectedPrice,
  getTripTypes,
  getSelectedTripTypes,
  getSelectedCountryCodes,
  getSelectedDestinationCodes,
  getSelectedDepartures,
  getSelectedTripLength,
], (dateFrom, dateTo, totalCount, priceRange, price, tripTypes, selectedTripTypes, selectedCountries, selectedDestinations, departures, tripLength) => {
  const [year, month, day] = (dateFrom.value ? dateFrom.value : '').split('-');

  let daySpan = NONE_CHOOSEN;

  if (dateTo && !dateTo.fallback) {
    const to = (new Date(dateTo.value)).getTime();
    const from = dateFrom.value ? new Date(dateFrom.value).getTime() : new Date().getTime() + DAY_IN_MS;
    daySpan = Math.ceil((to - from) / DAY_IN_MS) + 1;
    if (daySpan < 1) {
      daySpan = 1;
    }
  }

  const travelTypeCodes = tripTypes.filter((tt) => selectedTripTypes.indexOf(tt.key) >= 0).map((tt) => tt.gtm.value);

  return {
    travelDepartureCode: departures.map((d) => d.code).join(),
    travelDepartureYear: year,
    travelDepartureMonth: month,
    travelDepartureDay: day,
    travelResortCode: NONE_CHOOSEN,
    travelDestinationCode: selectedDestinations.length ? selectedDestinations.join() : NONE_CHOOSEN,
    travelType: (travelTypeCodes && travelTypeCodes.length && travelTypeCodes.join()) || NONE_CHOOSEN,
    travelHits: totalCount,
    travelPrice: price || priceRange.max,
    travelCountryCode: selectedCountries.length ? selectedCountries.join() : NONE_CHOOSEN,
    travelDepartureDateSpan: daySpan,
    ...(tripLength ? tripLength.gtm : {}),
  };
});
